import { PoliciesDataType } from 'domain/shared/compliance';
import { useEmployeeUrl } from 'domain/shared/employee';
import { useNavigate } from 'react-router-dom';
import { useFieldHelper } from 'framework/ui/field';
import { Button } from 'framework/ui/mui-builder';

type LinkToSignComplianceDocumentButtonProps = {
  isVisible?: boolean | ((data: PoliciesDataType) => boolean);
  buttonText?: string;
};

const LinkToSignComplianceDocumentButton = ({ buttonText = 'Sign' }: LinkToSignComplianceDocumentButtonProps) => {
  const navigate = useNavigate();
  const { getValue } = useFieldHelper<string>({ source: 'policyPath' });
  const { getEmployeeDocumentSignUrl } = useEmployeeUrl();

  const policyPath = getValue();

  const onClick = () => {
    const encodedPath = encodeURIComponent(policyPath);
    navigate(`${getEmployeeDocumentSignUrl({ path: encodedPath })}`);
  };

  return (
    <Button
      onClick={onClick}
      color="primary"
      sx={{
        whiteSpace: 'nowrap',
        minWidth: 'max-content',
      }}
    >
      {buttonText}
    </Button>
  );
};

export default LinkToSignComplianceDocumentButton;
